<template>
  <header class="base-header">
    <div class="d-flex align-items-center gap-6">
      <snow-button
        icon="ph ph-sidebar fs-20"
        size="sm"
        variant="borderless"
        @click="$emit('toggle-menu')"
      />

      <breadcrumbs />
    </div>

    <template v-if="$permissions.currentCompany">
      <div class="d-none d-lg-block">
        <span class="text-dark-40">
          Central
        </span>
        <strong>{{ $permissions.currentCompany.company.name }}</strong>
      </div>
      <div class="button-container">
        <snow-button
          @click="leaveCompany"
          size="sm"
          text="Sair"
          variant="outline"
        />
      </div>
    </template>

    <company-dropdown v-else-if="companies.length" :companies="companies" />
  </header>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import CompanyDropdown from "@/components/user/CompanyDropdown";

import { setToken } from "@/setup/api";
import { get } from "lodash";
export default {
  components: {
    CompanyDropdown,
    Breadcrumbs
  },
  data() {
    return {
      logoutDialog: false
    };
  },
  computed: {
    companies() {
      const base = get(this.$user, "user.company_base");
      return get(this.$user, "user.companies", []).filter(
        c => c.company.id !== base
      );
    }
  },
  methods: {
    leaveCompany() {
      setToken(this.$user.user.token);
      setTimeout(() => {
        window.location.href = "/";
      }, 1);
    }
  }
};
</script>

<style lang="scss">
.base-header {
  background-color: var(--bg-1);
  z-index: 1;

  padding: 20px 28px;
  height: var(--header-height);
  position: fixed;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--dark-10);
  box-sizing: border-box;

  .ph-sidebar {
    cursor: pointer;
  }

  .button-container {
    width: 50px;
  }
}
</style>
